import _ from 'lodash';
import materialConstants from '../constants/material-constants';
import Http from '../libs/http';
import orderConstants from '../constants/order-constants';
import applicantConstants from '../constants/applicant-constants';

export default {

  /**
   * 订单是否有纸质资料
   *
   * @param {Object} order 订单
   * @returns {Boolean} 订单是否有纸质资料
   */
  isOrderHavePaperyMaterial(order) {
    let requiredPaperyMaterialCount = 0;

    if (!order.applicant) return false;

    order.applicant.forEach((applicant) => {
      const rCount = applicant.material.material_required.filter(v => v.attr === 1).length;

      const oCount = applicant.material.material_optional.filter(v => v.attr === 1).length;

      requiredPaperyMaterialCount += (rCount + oCount);
    });

    return Boolean(requiredPaperyMaterialCount);
  },

  /**
  * 获取申请人的身份证没有身份证
  * @param {Object} applicant
  */
  getApplicantIdCarSpecialStatus(applicant) {
    if (applicant) {
      const allMaterials = applicant.material.material_required.concat(applicant.material.material_optional);
      if (allMaterials && allMaterials.length > 0) {
        const idCardMaterials = allMaterials.filter(material => material.pattern === 1);
        if (idCardMaterials && idCardMaterials.length > 0) {
          if (idCardMaterials[0].upload && idCardMaterials[0].upload.length > 0) {
            return idCardMaterials[0].upload[0].special_code;
          }
        }
      }
    }
    return 0;
  },

  /**
   * 为身份证资料加一项
   */
  addIdCardUploadItem(applicant, isIdCardSpecial) {
    if (applicant) {
      const indexInRequired = _.findIndex(applicant.material.material_required, material => material.pattern === 1);
      if (indexInRequired > -1) {
        if (isIdCardSpecial) {
          const newItem = Object.assign({}, applicant.material.material_required[indexInRequired].upload[0], { memo: '', pos: 2, temp: true });
          applicant.material.material_required[indexInRequired].upload.push(newItem);
        } else if (applicant.material.material_required[indexInRequired].upload.length === 1) {
          if (applicant.material.material_required[indexInRequired].upload[0].pos === 1) {
            const newItem = Object.assign({}, applicant.material.material_required[indexInRequired].upload[0],
              { elec_status: 1, special_code: 0, url: '', memo: '', pos: 2 });
            applicant.material.material_required[indexInRequired].upload.push(newItem);
          } else {
            const newItem = Object.assign({}, applicant.material.material_required[indexInRequired].upload[0],
              { elec_status: 1, special_code: 0, url: '', memo: '', pos: 1 });
            applicant.material.material_required[indexInRequired].upload.unshift(newItem);
          }
        }
      }
      const indexInOptional = _.findIndex(applicant.material.material_optional, material => material.pattern === 1);
      if (indexInOptional > -1) {
        if (isIdCardSpecial) {
          const newItem = Object.assign({}, applicant.material.material_optional[indexInOptional].upload[0], { memo: '', pos: 2 });
          applicant.material.material_optional[indexInOptional].upload.push(newItem);
        } else if (applicant.material.material_optional[indexInOptional].upload.length === 1) {
          if (applicant.material.material_optional[indexInOptional].upload[0].pos === 1) {
            const newItem = Object.assign({}, applicant.material.material_optional[indexInOptional].upload[0],
              { elec_status: 1, special_code: 0, url: '', memo: '', pos: 2 });
            applicant.material.material_optional[indexInOptional].upload.push(newItem);
          } else {
            const newItem = Object.assign({}, applicant.material.material_optional[indexInOptional].upload[0],
              { elec_status: 1, special_code: 0, url: '', memo: '', pos: 1 });
            applicant.material.material_optional[indexInOptional].upload.unshift(newItem);
          }
        }
      }
    }
    return applicant;
  },

  /**
   * 添加多页资料的upload项
   * @param {Object} applicant 申请人
   */
  addMultiMaterialUploadItem(applicant) {
    if (applicant) {
      applicant.material.material_optional.forEach((material, index) => {
        if (material.attr === 0) {
          // 多页资料
          const isMulti = material.style === 1;

          // 有待预审
          const isHaveWaittingForVerify = material.upload.some(upload => upload.elec_status === 2);

          // 有资料不完善
          const isHaveVerifyNotPass = material.upload.some(upload => upload.elec_status === 3);

          // 有资料不完善一定不会出现
          if (!isHaveVerifyNotPass) {
            if (isMulti && isHaveWaittingForVerify) {
              // pos 位置
              const lastUplpad = applicant.material.material_optional[index].upload[applicant.material.material_optional[index].upload.length - 1];
              const pos = lastUplpad.pos;

              // 最后一项是临时的空上传
              const isLastIsEmptyWaittingForUpload = !lastUplpad.url;

              // 如果有了就不要添加这个
              if (!isLastIsEmptyWaittingForUpload && material.pattern === materialConstants.PATTERN.defaul_0) {
                // 加一项
                applicant.material.material_optional[index].upload.push({
                  elec_status: 1,
                  memo: '',
                  pos: pos + 1,
                  special_code: 0,
                  url: '',
                  temp: true,
                });
              }
            }
          }
        }
      });
    }

    return applicant;
  },

  /**
   * 清空申请人的身份证图片
   * @param {Object} applicant 申请人
   */
  clearApplicantIdCardUpload(applicant, elec_status, special_code) {
    if (applicant) {
      const indexInRequired = applicant.material.material_required.findIndex(material => material.pattern === 1);
      if (indexInRequired > -1) {
        // 第一个temp设置为false和第二个temp设置为true的原因是
        // 进入清空的这里就是因为选择了没有身份证，而没有身份证的upload在order里面只会有第1个，第2个是手动加进去的，
        // 这样设置就是为了恢复这个状态，这样在判断是否资料都修改完毕了才不会出问题
        applicant.material.material_required[indexInRequired].upload = [{
          elec_status,
          memo: '',
          pos: 1,
          special_code,
          url: '',
          temp: false,
        }, {
          elec_status,
          memo: '',
          pos: 2,
          special_code,
          url: '',
          temp: true,
        }];

        applicant.material.material_required = [...applicant.material.material_required];
      }
      const indexInOptional = applicant.material.material_optional.findIndex(material => material.pattern === 1);
      if (indexInOptional > -1) {
        applicant.material.material_optional[indexInOptional].upload = [{
          elec_status,
          memo: '',
          pos: 1,
          special_code,
          url: '',
          temp: false,
        }, {
          elec_status,
          memo: '',
          pos: 2,
          special_code,
          url: '',
          temp: true,
        }];
        applicant.material.material_optional = [...applicant.material.material_optional];
      }
    }
    return applicant;
  },

  /**
   * 获取申请人的纸质资料的个数
   *
   * @param {Object} applicant 申请人
   * @returns {Number} 个数
   */
  getApplicantPaperyMaterialCount(applicant) {
    let count = 0;

    applicant.material && [
      applicant.material.material_required,
      applicant.material.material_optional,
    ].forEach((ma) => {
      count += ma.filter(m => m.attr === 1).length;
    });

    return count;
  },

  // 最小选择日期
  getCanSelectMinDate(holidayArr, needDays) {
    let minDays = needDays + 1;

    // 明天
    let date = new Date(new Date().getTime() + 86400000);

    // 获取毫秒值
    let timestamp = date.getTime();

    while (minDays) {
      // 下一天
      date = new Date(timestamp + 86400000);
      timestamp = date.getTime();

      // 格式化成日期字符串
      const holiday = date.format('yyyy-MM-dd');

      // 若不是放假日期，且不是周六周日，则计数一天，minDays-1。
      if (holidayArr.indexOf(holiday) === -1) {
        minDays -= 1;
      }
    }
    return date.format('yyyy-MM-dd');
  },

  // 计算申请人状态的样式
  calculateApplicantStatusClass(item, mark) {
    const statusClass = ['status-gray', 'status-red'];
    if (mark === 1) {
      if ([2, 5, 6, 8, 13, 17, 18].indexOf(item.applicant_status) > -1) {
        return statusClass[1];
      }
    } else if (mark === 2) {
      if ([2].indexOf(item.insurant_status) > -1) {
        return statusClass[0];
      } else if ([4].indexOf(item.insurant_status) > -1) {
        return statusClass[1];
      }
    }
    return '';
  },

  // 计算订单状态的样式 -- 需要删除
  calculateOrderStatusClass(order, mark) {
    const statusClass = ['gray-plane', 'red-plane'];
    if (mark === 1) {
      if ([0, 8].indexOf(order.order_status) > -1) {
        return statusClass[0];
      } else if ([1, 2, 3, 4, 10].indexOf(order.order_status) > -1) {
        return statusClass[1];
      }
    } else if (mark === 2) {
      if ([3].indexOf(order.order_status) > -1) {
        return statusClass[0];
      } else if ([0].indexOf(order.order_status) > -1) {
        return statusClass[1];
      }
    }
    return '';
  },

  // 获取选中的地址
  getSelectedAddress(returnAddress, peerAddresses) {
    if (toString.call(peerAddresses) !== '[object Array]') {
      return {};
    }

    const defaultAddress = peerAddresses.filter(peerAddress => peerAddress.is_default)[0] || {};

    if (typeof returnAddress !== 'object') {
      return defaultAddress;
    }

    const selectedAddress = peerAddresses.filter(peerAddress => peerAddress.province_code === returnAddress.province_code &&
                            peerAddress.city_code === returnAddress.city_code &&
                            peerAddress.county_code === returnAddress.county_code &&
                            peerAddress.detail_address === returnAddress.detail_address &&
                            peerAddress.addressee === returnAddress.addressee &&
                            peerAddress.mobile_phone === returnAddress.mobile_phone)[0];

    return selectedAddress || defaultAddress;
  },

  pickUpCheck(orderId) {
    return Http.post('/pickup_check', { user_order_id: orderId });
  },

  // 是否允许资料上传,仅对于订单而言, 支付前都可以修改
  isAllowUploadForOrder(order) {
    if (!order) return false;
    return [
      orderConstants.STATUS.waittingToUploadMaterial_1,
      orderConstants.STATUS.waittingToWriteApplicantion_2,
      orderConstants.STATUS.waittingToPay_3,
      orderConstants.STATUS.waittingToSelectGoToEmbassyTime_10,
    ].indexOf(order.order_status) > -1;
  },


  // 是否允许资料上传,仅对于申请人而言
  isAllowUploadForApplicant(applicant) {
    if (!applicant) return false;
    return applicant.applicant_status === applicantConstants.STATUS.verifyNotPassed_2;
  },

  // 资料的单项uploadItem是否允许上传
  isAllowUpload(order, applicant, upload) {
  // 不存在则禁用
    if (!order || !applicant) return false;

    // 申请人已退款，则不允许上传
    if (applicant.applicant_status === applicantConstants.STATUS.refundSuccess_8) return false;

    const orderStatusAllowUpload = this.isAllowUploadForOrder(order);

    // 预审不通过 + upload处于上传成功和预审失败状态
    // eslint-disable-next-line no-nested-ternary
    const status = !upload
      ? undefined
      : 'elec_status' in upload
        ? upload.elec_status
        : upload.id_photo_status;

    const materialAllowUpload =
    this.isAllowUploadForApplicant(applicant) &&
    status &&
    [
      materialConstants.ELEC_STATUS.waittingForUploadMaterial_1,
      materialConstants.ELEC_STATUS.waittingForVerified_2,
      materialConstants.ELEC_STATUS.unqualified_3,
    ].indexOf(status) > -1;

    return orderStatusAllowUpload || materialAllowUpload;
  },
};



// WEBPACK FOOTER //
// ./src/services/order-service.js